import { isConfigurableSchema } from '@main/shared/utils';
import z from 'zod/v4';

export function hasConfigurableAuthSchemas({
  configSchema,
  encryptedConfigSchema,
}: {
  configSchema?: z.ZodObject;
  encryptedConfigSchema?: z.ZodObject;
}) {
  return Boolean(
    (configSchema && isConfigurableSchema(configSchema)) ||
      (encryptedConfigSchema && isConfigurableSchema(encryptedConfigSchema)),
  );
}
